import { Component, HostListener, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { NavParams, Events, ToastController, AlertController, LoadingController, } from 'ionic-angular';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { ViewController } from 'ionic-angular';
import { EncrDecrServiceProvider } from '../../providers/encr-decr-service/encr-decr-service';
import { ConfigureServiceProvider } from '../../providers/configure-service/configure-service';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { StoreWrapProvider } from '../../providers/store-wrap/store-wrap';
import { ContactManagerProvider } from '../../providers/contact-manager/contact-manager';
import { ContextMenuService, ContextMenuComponent } from 'ngx-contextmenu';

const defautSharePath = 0;
const NoIndex = -1;
@Component({
  selector: 'page-drive-share',
  templateUrl: 'drive-share.html',
})

export class DriveSharePage {
  @ViewChild('userinput', { 'static': false }) userinput: ElementRef;
  @Output() dataSet = new EventEmitter();
  mailIndex: any = 0;
  shareType: any = '';
  showShareSettings: any = false;
  showEditSettings: any = false;
  showLinkSettings: any = false;
  showShare: any = true;
  editAccessForm: any = false;
  uneditAccess: any = true;
  toggleShareAccess: any = [];
  accessActiveData: any = {};
  loginUserName: any = '';
  mailDataLink: any = '';
  mailId: any = '';
  mailScheduler: any = { 'TOID': '', "CC": "", "BCC": "", "FROMID": "", "SUBJECT": "", "BODY": "", "ShareID": "" }
  ShareID: any;
  @ViewChild("insideElement", { static: true }) insideElement;
  @ViewChild("divElement", { static: true }) divElement;
  @ViewChild("emailElement", { static: true }) emailElement;
  shareData: any = {};
  shareDataSet: any;
  selectedRowData: any = {};
  shareDataAccess: any = {}
  Subject: any = '';
  sendMailAction: boolean = false;
  mailItems: any = []
  editView: boolean = false;
  ObjLinkDisplayName: any = "";
  footerSave: boolean = false;
  tempId: any;
  arrTemplates: any = [];
  fields: any = [];
  arrTemplateFields: any = [];
  mailFolderId: any;
  toSelectedFolder: any[];
  Email_ID: any = [];
  ContextOpen: boolean = false;
  emailLen: any = [];
  sharedFolder: any = {};
  emailConfirmation: boolean = true;
  copyLinkActive: boolean = false;
  individualEmail: boolean = true;
  copyLinkShow: boolean = false;
  shareFolderButton: boolean = false;


  target: any;
  contextMenuAddContainer: any = '';

  mailIdx: any = 0;
  fieldDataMailIdx = 0;
  fieldDataSubjectIdx = 0;
  fieldDataMessageIdx = 0;
  @ViewChild(ContextMenuComponent, { static: true }) public contextMenu: ContextMenuComponent;
  Message: any;
  SubjectMessage: any;
  mail_ID: any = [];
  smsBody: any;
  emailId: any;
  isChecked: boolean = false;
  smsMessage: any = ''
  smsParams = {
    'phoneNumber': [],
    'SmsMessage': '',
    'enableSms': false
  }
  mailParams = {
    'Email_id': [],
    'Subject': '',
    'Message': '',
    'accessActiveData': "",
    "saveLinkField": "",
    "individualEmail": true,
    "editAccess": false,
  }
  sendData: any = {
    "sendParams": [],
  };
  saveButtonDisable: boolean = false;
  loader: any;
  ReceiverEmail: any = [];
  ComponentName: any;
  templateFields: any = [];
  selectedValue: any = "";
  pushParms: any;
  saveLinkButton: boolean = true
  contextMenuActions: any;
  currentFolder: any;
  pushArrayParams: { PushArray: any; };

  selectedField: any = [];
  pushData: any = [];
  grpEmails: any = [];
  groupDatas: any;
  dataIdx = 0;
  constructor(private loadingController: LoadingController, private alertCtrl: AlertController, public driveServiceProvider: DriveServiceProvider, public navParams: NavParams, public element: ElementRef, private contextMenuService: ContextMenuService, public storeWrap: StoreWrapProvider, public contactManager: ContactManagerProvider, public configApiService: ConfigApiServiceProvider, public configureService: ConfigureServiceProvider, private driveService: DriveServiceProvider, public viewCtrlSecurity: ViewController, private EncrDecrService: EncrDecrServiceProvider, public event: Events, private toastController: ToastController) {
    this.shareData['Email_ID'] = [];
    this.toggleShareAccess = [
      { 'id': 2, 'icon': 'create', 'label': 'Specific People', 'value': 'edit', 'text': 'Specific People can View', 'active': 'active' },
      { 'id': 1, 'icon': 'eye', 'label': 'Anyone With the link', 'value': 'view', 'text': 'Anyone With the link can View', 'active': 'inactive' }
    ]
    this.currentFolder = this.navParams.get('currentFolder');
    if (this.currentFolder == undefined) {
      this.currentFolder = this.driveService.objCurrentFolder
    }
    this.contextMenuActions = [
      {
        arrayList: this.contactManager.getCurrentFolderTemplate(this.currentFolder),
        click: (event, item) => this.getFields(item),
        mouseover: (event, item) => this.getFields(item),
        enabled: (item) => true,
        visible: (item) => true,
        subActions: [{
          arrayList: this.arrTemplateFields,
          click: (event, item) => alert('submenu'),
          enabled: (item) => true,
          visible: (item) => true,
        }],
      }
    ];
  }

  ngOnInit() {
    this.selectedRowData = this.navParams.get('selectedRowData') ? this.navParams.get('selectedRowData') : [];
    this.shareDataSet = this.navParams.get('shareDataSet');
    this.mailDataLink = this.navParams.get('dataLink');
    this.ShareID = this.navParams.get('ShareID');
    this.ComponentName = this.navParams.get('ComponentName');

    this.ReceiverEmail = this.shareDataSet['ReceiverEmail']
    this.loginUserName = this.configureService.getLoginData()["user"];
    this.Subject = this.loginUserName + " has shared an information to you.";
    if (this.navParams.get('currentFolderTemplate')) {
      this.ObjLinkDisplayName = this.navParams.get('currentFolderTemplate');
    } else {
      this.ObjLinkDisplayName = this.navParams.get('currentFolderName');
    }

    this.sharedFolder = JSON.stringify(this.shareDataSet['SharedInfo']['sharedFolder']);
    this.getTemplates()
    let templateProp = this.driveService.storeWrap.storeTemplates[this.shareDataSet.TemplateID];
    if (this.shareDataSet['ShareType'] == 'File') {
      if (templateProp.mailParams == undefined) {
        this.accessActiveData = this.toggleShareAccess.find(item => item.active == 'active');
      } else if (templateProp.mailParams.accessActiveData == '') {
        this.accessActiveData = this.toggleShareAccess.find(item => item.active == 'active');
      } else {
        this.accessActiveData = templateProp.mailParams.accessActiveData
        this.toggleShareAccess.forEach(ele => {
          if (ele.id == this.accessActiveData.id) {
            ele.active = this.accessActiveData.active;
          } else {
            ele.active = 'inactive'
          }
        })
        this.mailParams.accessActiveData = templateProp.mailParams.accessActiveData;
      }
    } else {
      this.accessActiveData = this.toggleShareAccess.find(item => item.active == 'active');
    }
    if (templateProp.mailParams && templateProp.mailParams.saveLinkField && templateProp.mailParams.saveLinkField != '') {
      this.selectedValue = templateProp.mailParams.saveLinkField;
      this.mailParams.saveLinkField = templateProp.mailParams.saveLinkField;
    }
    if (templateProp.mailParams) {
      if (templateProp.mailParams.editAccess == true) {
        this.uneditAccess = false;
        this.editAccessForm = true;
      } else {
        this.editAccessForm = false;
        this.uneditAccess = true;
      }
      this.editView = templateProp.mailParams.editAccess;
      this.mailParams.editAccess = templateProp.mailParams.editAccess;
    }
    if (templateProp.smsParams) {
      this.isChecked = templateProp.smsParams.enableSms;
      this.smsParams.enableSms = this.isChecked;
      this.individualEmail = templateProp.mailParams.individualEmail;
    }
    if (this.shareDataSet['ShareType'] == 'File') {
      let sendParams;
      if (Object.keys(templateProp).includes('sendParams')) {
        sendParams = this.driveService.clone(templateProp.sendParams);
        this.sendData.sendParams = sendParams.sendParams;
      }
      if (sendParams != undefined && templateProp.smsParams != undefined && templateProp.mailParams != undefined) {
        this.footerSave = true;
        this.shareData.smsMessage = templateProp.smsParams.SmsMessage;
        sendParams.sendParams.forEach(element => {
          this.shareData.Email_ID = element;
        });
        this.shareData.SubjectMessage = templateProp.mailParams.Subject;
        this.shareData.Message = templateProp.mailParams.Message;
      } else if (templateProp.sendParams != undefined && templateProp.smsParams != undefined) {
        this.footerSave = true;
        this.shareData.smsMessage = templateProp.smsParams.SmsMessage;
        sendParams.sendParams.forEach(element => {
          this.shareData.Email_ID = element;
        });
      } else if (sendParams != undefined && templateProp.mailParams != undefined) {
        this.footerSave = true;
        sendParams.sendParams.forEach(element => {
          this.shareData.Email_ID = element;
        });
        this.shareData.SubjectMessage = templateProp.mailParams.Subject;
        this.shareData.Message = templateProp.mailParams.Message;
      }
    }else if(this.shareDataSet['ShareType'] == 'Folder'){
      if(this.shareDataSet['SharedInfo']['sharedFolder']['mailParams'] != undefined){
        this.footerSave = true;
        this.shareData.Email_ID = this.shareDataSet['SharedInfo']['sharedFolder']['mailParams']['Email_id'];
        this.shareData.SubjectMessage = this.shareDataSet['SharedInfo']['sharedFolder']['mailParams']['Subject']
        this.shareData.Message = this.shareDataSet['SharedInfo']['sharedFolder']['mailParams']['Message'];
        this.editView = this.shareDataSet['SharedInfo']['sharedFolder']['mailParams'].editAccess;
      if (this.shareDataSet['SharedInfo']['sharedFolder']['mailParams'].accessActiveData == '') {
          this.accessActiveData = this.toggleShareAccess.find(item => item.active == 'active');
        } else {
          this.accessActiveData = this.shareDataSet['SharedInfo']['sharedFolder']['mailParams'].accessActiveData
          this.toggleShareAccess.forEach(ele => {
            if (ele.id == this.accessActiveData.id) {
              ele.active = this.accessActiveData.active;
            } else {
              ele.active = 'inactive'
            }
          })
          this.mailParams.accessActiveData = this.shareDataSet['SharedInfo']['sharedFolder']['mailParams'].accessActiveData;
        }
      }else{
        this.accessActiveData = this.toggleShareAccess.find(item => item.active == 'active');
      }

    }
  }



  ngAfterViewInit() {
  }

  onSelect(item) {
    this.footerSave = true;

  }
  public onAdd(item) {
    this.footerSave = true;
    if (this.shareData.Email_ID.length == 0 && this.mailItems == 0) {
      if (item.value != '') {
        this.mailItems.push(item);
        this.shareData.Email_ID.push(item.value);
      }
    } else {
      let index: any = this.shareData.Email_ID.findIndex(element => element == item.value);
      if (index == -1) {
        if (this.mailItems.findIndex(element => element.value == item.value) == -1) {
          if (item.value != '') {
            this.mailItems.push(item);
          }
        }
        if (item.value != '') {
          this.shareData.Email_ID.push(item.value);
        }
      } else if (index >= 0) {
        this.mailItems.splice(index, 1);
        this.shareData.Email_ID.splice(index, 1);
        if (item.value != '') {
          this.mailItems.push(item);
          this.shareData.Email_ID.push(item.value);
        }
      }
    }
  }

  public onRemove(item) {
    this.footerSave = true;
    let shareDataEmailIndex: any = this.shareData.Email_ID.findIndex(element => element == item.value);
    let mailItemsIndex: any = this.mailItems.findIndex(element => element.value == item.value);
    if (mailItemsIndex >= 0) {
      this.mailItems.splice(mailItemsIndex, 1);
    }
    if (shareDataEmailIndex >= 0) {
      this.shareData.Email_ID.splice(shareDataEmailIndex, 1);
    }

    if (this.mailItems.length == 0) {
      this.shareData.Email_ID = []
    }
  }
  onChange(event) {
    if (event.target.value.includes(",")) {
      let emailValues = event.target.value.split(",");
      emailValues.forEach(element => {
        this.onAdd({ 'display': element, 'value': element });
      });
      event.target['value'] = '';
    } else {
      this.emailLen.push(event.target.value);
    }
  }
  focusout(event) {
    if (this.shareDataSet['ShareType'] == 'Folder') {
      let shareDataLen = 0;
      if ((this.shareData.Email_ID.length == shareDataLen && this.emailLen.length == shareDataLen) && this.ContextOpen == false) {
        this.footerSave = false;
        this.closeLinkSetting();
        this.copyLinkShow = false;
        var message = this.toastController.create({
          message: 'Please Enter valid EmailId!..',
          duration: this.configApiService.toastDuration
        });
        message.present();
      } else {
        this.footerSave = true;
        this.onAdd({ 'display': event.target['value'].replace(/[ ,]+/g, ""), 'value': event.target['value'].replace(/[ ,]+/g, "") });
        event.target['value'] = '';
      }
    } else {
      this.footerSave = true;
      this.onAdd({ 'display': event.target['value'].replace(/[ ,]+/g, ""), 'value': event.target['value'].replace(/[ ,]+/g, "") });
      event.target['value'] = '';
    }
  }

  onKey(event: KeyboardEvent) {
    this.footerSave = true;
    if (event.which == 32 || event.which == 188 || event.which == 9) {//space
      this.onAdd({ 'display': event.target['value'].replace(/[ ,]+/g, ""), 'value': event.target['value'].replace(/[ ,]+/g, "") });
      event.target['value'] = '';
    } else if(event.target['value'].includes(",")) {
      let emailValues = event.target['value'].split(",");
      emailValues.forEach(element => {
        this.onAdd({ 'display': element, 'value': element });
      });
      event.target['value'] = '';
    }
  }

  editFormAccess(e) {
    this.footerSave = true;
    if (e == 'edit') {
      this.mailParams.editAccess = true;
      this.uneditAccess = false;
      this.showEditSettings = false;
      this.editAccessForm = true;
    }
    else {
      this.mailParams.editAccess = false;
      this.editAccessForm = false;
      this.showEditSettings = false;
      this.uneditAccess = true;
    }
    this.saveButtonDisable = true;
  }


  copyLink() {
    this.userinput.nativeElement.select();
    document.execCommand("copy");
    var message = this.toastController.create({
      message: 'copied link successfully',
      duration: this.configApiService.toastDuration
    });
    message.present();
  }

  linkGenerate() {
    let accessType: any = this.accessActiveData.id == "1" ? 'public' : 'private';
    this.mailId = this.shareData.Email_ID;
    if (!this.ShareID && this.sendMailAction == false) {
      if ((this.shareData.Email_ID.length && accessType == 'private') || (accessType == 'public')) {
        this.postShareData();
        this.shareFolderButton = true;
      } else {
        let requiredFieldMessage = 'Please, Enter the Valid Email Id';
        var message = this.toastController.create({
          message: requiredFieldMessage,
          duration: this.configApiService.toastDuration
        });
        message.present();
        this.closeLinkSetting();
        this.copyLinkShow = false;
      }

    } if (!this.ShareID && this.sendMailAction == true) {
      this.postShareData();
      this.shareFolderButton = true;
    }
    else if (this.ShareID && this.sendMailAction == true) {
      this.shareDataSet['ShareID'] = this.ShareID;
      this.postShareData();
      this.shareFolderButton = true;
    } else if (this.ShareID && this.sendMailAction == false && (this.shareDataSet["ReceiverEmail"] != this.shareData.Email_ID.toString() || this.shareDataSet['SharedInfo']['accessType'] != accessType || this.shareDataSet['SharedInfo']['editAccess'] != this.editView)) {
      if (!this.shareData.Email_ID.length && accessType == 'private') {
        let requiredFieldMessage = 'Please, Enter the Valid Email Id';
        var message = this.toastController.create({
          message: requiredFieldMessage,
          duration: this.configApiService.toastDuration
        });
        message.present();
        this.closeLinkSetting();
        this.copyLinkShow = false;
      } else {
        this.shareDataSet['ShareID'] = this.ShareID;
        this.postShareData();
        this.shareFolderButton = true;
      }
    }
  }

  objFolderData: any = {};
  postShareData() {
    this.shareDataSet['SharedInfo'];
    this.objFolderData = JSON.stringify(this.driveServiceProvider.objCurrentFolder.folders)
    this.accessActiveData.id == "1" ? this.shareDataSet['SharedInfo']['accessType'] = 'public' : this.shareDataSet['SharedInfo']['accessType'] = 'private';
    this.shareData.Email_ID != undefined || this.shareData.Email_ID.length > 0 ? this.shareData.Email_ID.toString() : '';
    this.shareDataSet['SharedInfo']['sharedFolder']['IsReadOnlyShare'] = this.editView == true ? 'NO' : 'YES';
    if (this.shareData.Email_ID.length > 1) {
      this.shareDataSet["ReceiverEmail"].push({ email_id: this.shareData.Email_ID[this.mailIndex] });
      this.shareDataSet["AccessType"] = this.editView == true ? 'Editable' : 'Non Editable';
      if (this.shareDataSet.ShareType == "File") {
        this.multiMailSend();
      } else {
        this.driveService.shareInfoFolder(this.shareDataSet['SharedInfo'].sharedFolder, this.shareDataSet['SharedInfo'], (_respData) => {
          this.shareDataSet['SharedInfo'].sharedFolder = JSON.parse(this.sharedFolder)
          this.shareDataSet.ShareID = _respData;
          this.ShareID = _respData;
          this.shareDataSet['ReceiverEmail'] = JSON.stringify(this.shareDataSet["ReceiverEmail"]);
          this.configApiService.pushRequest(this.shareDataSet, this.linkGenerateCbck);
        });
      }
    } else if (this.shareData.Email_ID.length == 1 || this.shareDataSet['SharedInfo']['accessType'] == 'public') {
      // this.shareDataSet["ReceiverEmail"].push({ email_id: this.shareData.Email_ID[0] });
      this.shareDataSet["AccessType"] = this.editView == true ? 'Editable' : 'Non Editable';
      if (this.shareDataSet.ShareType == "File") {
        this.multiMailSend();
      } else {
        this.driveService.shareInfoFolder(this.shareDataSet['SharedInfo'].sharedFolder, this.shareDataSet['SharedInfo'], (_respData) => {
          this.shareDataSet['SharedInfo'].sharedFolder = JSON.parse(this.sharedFolder)
          this.shareDataSet.ShareID = _respData;
          this.ShareID = _respData;
          this.shareDataSet['ReceiverEmail'] = JSON.stringify(this.shareDataSet["ReceiverEmail"]);
          this.driveServiceProvider.objCurrentFolder.folders = JSON.parse(this.objFolderData);
          this.configApiService.pushRequest(this.shareDataSet, this.linkGenerateCbck);
        });
      }
    }
  }

  presentLoading() {
    this.loader = this.loadingController.create({
      spinner: 'ios',
      content: 'Sending Mail Please wait...',
      cssClass: 'loaderSpinner',
    });
    this.loader.present();
  }

  multiMailSend() {
    if (this.selectedRowData[this.mailIdx] != undefined) {
      this.shareDataSet['SharedInfo'].rowData = []
      this.shareDataSet['SharedInfo'].rowData.push(this.selectedRowData[this.mailIdx]);
      this.sendMailToUsers();
    } else {
      if (this.loader) {
        this.loader.dismiss();
        this.toastPresent();
        this.pushLinkToField();
      }
    }
  }

  sendMailToUsers() {
    this.configApiService.pushRequest(this.shareDataSet, this.linkGenerateCbck);
  }

  toastPresent() {
    var message = this.toastController.create({
      message: 'Mail Sent Successfully',
      duration: this.configApiService.toastDuration
    });
    message.present();
    this.shareDataSet["ReceiverEmail"] = [];
    if (this.shareDataSet['ShareType'] == 'File') {
      this.pushTemplateProperty();
    }
    this.driveServiceProvider.objCurrentFolder.folders = JSON.parse(this.objFolderData);
    this.sendMailAction = false;
    this.dismissShare()
  }

  linkGenerateCbck = (responsedata => {
    if (this.driveService.objCurrentFolder.hasOwnProperty('IsReadOnlyShare')) {
      delete this.driveService.objCurrentFolder['IsReadOnlyShare'];
    }

    this.mailDataLink = this.generateLinkUrl(responsedata["ShareID"]);
    this.saveLinkButton = false;
    this.userinput.nativeElement.value = this.mailDataLink;

    if (this.sendMailAction == true) {
      // if (this.shareDataSet['ShareType'] != 'File' && this.emailConfirmation == false) {
      //   JSON.parse(this.sharedFolder)['IsReadOnlyShare'] = this.editView == true ? 'NO' : 'YES';
      //   this.pushShareFolder();
      // } else {
      this.sendMailPush(this.shareDataSet['SharedInfo'].rowData);
      // }
    }
    if (this.shareDataSet['ShareType'] == 'File' && this.selectedValue != "" && this.mailDataLink != '' && this.mailDataLink != undefined) {
      this.selectedRowData[this.mailIdx][this.selectedValue] = this.mailDataLink;
      this.selectedRowData[this.mailIdx]['rptname'] = this.pushParms.rptname;
      delete this.selectedRowData[this.mailIdx].RowNumber;
    }
    else {
      if (this.shareDataSet['ShareType'] != 'File' && this.accessActiveData.id == '1') {
        this.copyLink();
      }
    }
    if (this.copyLinkActive == true) {
      this.copyLink();
    }
  });

  generateLinkUrl(shareId) {
    this.ShareID = shareId;
    let urlParams = shareId + '&studio=' + this.configureService.getStudio() + '&userid=' + this.configureService.getLoginUserID();
    let encUrlParams = this.EncrDecrService.encrypt('DRIVESYNC123##', urlParams);
    let generateUrl: any = '';
    if (window.location.search) {
      generateUrl = window.location.origin + window.location.pathname + window.location.search + '&ShareID=' + encUrlParams;
    } else {
      generateUrl = window.location.origin + window.location.pathname + '/?ShareID=' + encUrlParams;
    }
    return generateUrl
  }

  sendMail() {
    this.sendMailAction = true;
    if (this.shareDataSet['ShareType'] == 'File' && !this.individualEmail) {
      if (this.shareData.Email_ID.length > 0 && this.shareData.SubjectMessage != undefined) {
        this.groupOfData();
      } else {
        this.sendMailAction = false;
        let requiredFieldMessage: any = '';
        if (this.shareData.Email_ID.length == 0) {
          requiredFieldMessage = 'Please, Enter the Valid Email Id';
        } else if (this.shareData.SubjectMessage == undefined) {
          requiredFieldMessage = 'Message Field Cannot be empty';
        }
        message = this.toastController.create({
          message: requiredFieldMessage,
          duration: this.configApiService.toastDuration
        });
        message.present();
      }
    } else {
      if (this.shareDataSet['ShareType'] != 'File') {
        this.checkUser();
      }
      if (this.emailConfirmation == false) {
        if (this.shareDataSet['ShareType'] != 'File') {
          JSON.parse(this.sharedFolder)['IsReadOnlyShare'] = this.editView == true ? 'NO' : 'YES';
          this.pushShareUser();
        }
      } else {
        if (this.ShareID) {
          if (this.shareData.Email_ID.length > 0) {
            this.presentLoading();
            this.sendMailPush(this.shareDataSet['SharedInfo'].rowData);
          } else {
            this.sendMailAction = false;
            let requiredFieldMessage: any = '';
            if (this.shareData.Email_ID.length == 0) {
              requiredFieldMessage = 'Please, Enter the Valid Email Id';
            }
            var message = this.toastController.create({
              message: requiredFieldMessage,
              duration: this.configApiService.toastDuration
            });
            message.present();
          }
        } else {
          if (this.shareData.Email_ID.length > 0 && this.shareData.SubjectMessage != undefined) {
            this.presentLoading();
            this.linkGenerate();
          } else {
            this.sendMailAction = false;
            let requiredFieldMessage: any = '';
            if (this.shareData.Email_ID.length == 0) {
              requiredFieldMessage = 'Please, Enter the Valid Email Id';
            } else if (this.shareData.SubjectMessage == undefined) {
              requiredFieldMessage = 'Message Field Cannot be empty';
            }
            message = this.toastController.create({
              message: requiredFieldMessage,
              duration: this.configApiService.toastDuration
            });
            message.present();
          }
        }
      }
    }
  }
  enableSms() {
    this.isChecked != this.isChecked;
    this.footerSave = true;
    this.smsParams.enableSms = this.isChecked;
    this.saveButtonDisable = true;
  }
  sendMailPush(currentRowData) {
    if (currentRowData != undefined) {
      this.ReplaceTemplateParams(currentRowData)
    } else {
      this.Email_ID = this.shareData['Email_ID'];
      this.SubjectMessage = this.shareData.SubjectMessage;
    }
    let mailBody = this.convertHtml(this.Message, this.mailDataLink);
    this.smsBody = this.driveService.sendSms(this.smsMessage)
    let regExp = /[a-zA-Z]/g;
    if (this.shareDataSet['ShareType'] == 'File') {
      if (this.isChecked == true) {
        if (regExp.test(this.Email_ID[this.mailIndex]) == false) {
          this.Email_ID[this.mailIndex] = parseInt(this.Email_ID[this.mailIndex])
        }
        if (typeof this.Email_ID[this.mailIndex] == 'number') {
          this.mailScheduler = { 'TOID': this.Email_ID[this.mailIndex], 'BODY': this.smsBody, 'ShareID': this.ShareID };
          let objPushParams = Object.assign({}, this.configApiService.driveApi.pushSMSShareUser.params, this.mailScheduler);
          this.configApiService.pushRequest(objPushParams, this.mailSentResponseStatus);
        } else if (this.mailId.toString() == this.shareData.Email_ID.toString()) {
          this.mailParams.Message = this.shareData.Message;
          this.mailParams.Subject = this.shareData.SubjectMessage;
          this.mailScheduler = { 'TOID': this.Email_ID[this.mailIndex], 'CC': '', 'BCC': '', 'FROMID': this.loginUserName, 'BODY': mailBody, 'ShareID': this.ShareID, 'SUBJECT': this.SubjectMessage };
          let objPushParams = Object.assign({}, this.configApiService.driveApi.pushMailShareUser.params, this.mailScheduler);
          this.configApiService.pushRequest(objPushParams, this.mailSentResponseStatus);
        } else {
          this.linkGenerate();
        }
      } else {
        if (this.mailId.toString() == this.shareData.Email_ID.toString()) {
          this.mailParams.Message = this.shareData.Message;
          this.mailParams.Subject = this.shareData.SubjectMessage;
          this.mailScheduler = { 'TOID': this.Email_ID[this.mailIndex], 'CC': '', 'BCC': '', 'FROMID': this.loginUserName, 'BODY': mailBody, 'ShareID': this.ShareID, 'SUBJECT': this.SubjectMessage };
          let objPushParams = Object.assign({}, this.configApiService.driveApi.pushMailShareUser.params, this.mailScheduler);
          this.configApiService.pushRequest(objPushParams, this.mailSentResponseStatus);
        } else {
          this.linkGenerate();
        }
      }
    } else {
      if (this.mailId.toString() == this.shareData.Email_ID.toString()) {
        this.mailScheduler = { 'TOID': this.Email_ID[this.mailIndex], 'CC': '', 'BCC': '', 'FROMID': this.loginUserName, 'BODY': mailBody, 'ShareID': this.ShareID, 'SUBJECT': this.SubjectMessage };
        let objPushParams = Object.assign({}, this.configApiService.driveApi.pushMailShareUser.params, this.mailScheduler);
        this.configApiService.pushRequest(objPushParams, this.mailSentResponseStatus);
      } else {
        this.linkGenerate();
      }
    }

  };


  mailSentResponseStatus = ((responsedata) => {
    if (this.Email_ID.length > 1) {
      if (this.mailIndex + 1 == this.Email_ID.length) {
        this.ShareID = '';
        this.mailIdx++;
        this.mailIndex = 0;
        this.fieldDataMailIdx = 0;
        this.fieldDataMessageIdx = 0;
        this.fieldDataSubjectIdx = 0;
        this.Email_ID = [];
        if (this.selectedRowData != undefined) {
          this.multiMailSend()
        } else {
          this.loader.dismiss();
          this.toastPresent()
        }
      } else {
        this.mailIndex = this.mailIndex + 1;
        this.sendMailPush(this.shareDataSet['SharedInfo'].rowData);
      }

    } else {
      this.ShareID = '';
      this.mailIdx++;
      this.fieldDataMailIdx = 0;
      this.fieldDataMessageIdx = 0;
      this.fieldDataSubjectIdx = 0;
      this.Email_ID = [];
      if (this.selectedRowData != undefined) {
        this.multiMailSend()
      } else {
        this.loader.dismiss();
        this.toastPresent()
      }
    }


  });

  convertHtml(text, link) {
    let bodyHtml: any = '';
    bodyHtml += '<div  style="width: 35%;"><table border="0" cellpadding="0" cellspacing="0" style="width: 100%;">' +
      '<thead border="0" cellpadding="0" cellspacing="0" width="78%"><tr><td>';
    if (text) {
      bodyHtml += '<div style="margin: 12px;">' + text.replace(/\r\n|\r|\n/g, "</p><br /><p>") + '</div>';
    }
    bodyHtml += '</td></tr></thead><tbody style="padding: 12px;margin: 1px; background-color: #e6e6e694;" border="0" cellpadding="0" cellspacing="0">' +
      '<tr border="0" cellpadding="0" cellspacing="0"><td border="0" cellpadding="0" cellspacing="0">' +
      '<div style="margin: 12px;display: flex;"><div style="margin-left: 20px;"><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/Google_Docs_logo.svg/740px-Google_Docs_logo.svg.png" style="width: 46px;">' +
      '</div><div style="margin-top: 25px;margin-left: 16px;"><span style="font-weight:bold">' + this.ObjLinkDisplayName + '</span></div></div>' +
      '</td></tr><tr border="0" cellpadding="0" cellspacing="0"><td border="0" cellpadding="0" cellspacing="0"><div style="margin: 12px;">' +
      "<a href='" + link + "' style='color: #fff;background-color: #467fff;padding:6px 21px;border: 1px solid;border-radius: 3px;font-size: 16px;margin-left: 8px;cursor: pointer;text-decoration:none'>open</a>" +
      '</div></td></tr></tbody><tfoot style="margin:1px;background-color: #cccccc;"><tr><td></td>' +
      '</tr></tfoot></table></div><br>' +
      '<div style="height: 50px;"><span style="margin-top:10px">Regards,<br><span> ' + this.loginUserName + '</span></span></div>';
    return bodyHtml;
  }

  pushTemplateProperty() {
    let currentTemplateProps = this.driveService.storeWrap.storeTemplates[this.shareDataSet.TemplateID]
    this.mailParams.Message = this.shareData.Message;
    this.mailParams.Subject = this.shareData.SubjectMessage;
    this.smsParams.SmsMessage = this.shareData.smsMessage;
    this.sendData.sendParams.push(this.shareData.Email_ID);
    currentTemplateProps['mailParams'] = this.mailParams;
    currentTemplateProps['smsParams'] = this.smsParams;
    currentTemplateProps['sendParams'] = this.sendData;
    currentTemplateProps['mailParams']['individualEmail'] = this.individualEmail;
    let postData = this.driveService.storeWrap.storeTemplates[this.shareDataSet.TemplateID];
    let pushParams = Object.assign({}, this.configApiService.driveApi.PushTemplateParams, { "ScreenName": this.shareDataSet.TemplateID, "PluginData": postData, "Action": "update", "userid": this.configureService.getLoginUserID() })
    this.configApiService.pushRequest(pushParams, (resp) => {
      if (resp == "SUCCESS") {
        let toast = this.toastController.create({
          message: "Data save successfully!..",
          duration: this.configApiService.toastDuration
        });
        toast.present();
        this.saveButtonDisable = false;
      }
    })
  }

  pushFolderProperty() {
    this.shareDataSet['SharedInfo']['sharedFolder']['mailParams'] = [];
    this.mailParams.Message = this.shareData.Message;
    this.mailParams.Subject = this.shareData.SubjectMessage;
    this.mailParams.Email_id = this.shareData.Email_ID;
    this.mailParams.accessActiveData = this.toggleShareAccess.find(item => item.active == 'active');
    this.shareDataSet['SharedInfo']['sharedFolder']['mailParams'] = this.mailParams;
    let pushFolderParams = {
      'folder': this.shareDataSet['SharedInfo']['sharedFolder'],
      'action': 'update',
      'appCode': this.configApiService.currentDriveApp['app_code'],
      'userid': this.configureService.getLoginUserID()
    }
    let objFolder = Object.assign({}, this.configApiService.driveApi['pushFolder']['params'],this.driveService.storeWrap.licenceClientDB,pushFolderParams);
    this.configApiService.customRequest(this.configApiService.pushFolder, objFolder, (resFolder) => {
      const toast = this.toastController.create({
        message: 'Folder Property Saved Successfully.',
        duration: this.configApiService.toastDuration
      });
      toast.present();
    })
  }

  dismissShare() {
    this.viewCtrlSecurity.dismiss();
  }

  shareAccess(e, ffdata) {
    this.footerSave = true;
    this.saveButtonDisable = true;
    this.toggleShareAccess.find(function (item) { if (item.active == 'active') { item.active = 'inactive' } });
    ffdata.active = 'active';
    this.accessActiveData = ffdata;
    this.mailParams.accessActiveData = this.accessActiveData;
    if (this.accessActiveData.label == 'Anyone With the link') {
      this.copyLinkShow = true;
    } else {
      this.copyLinkShow = false;
    }
    this.showShareSettings = false;
    this.saveLinkButton = true;
  }

  shareAccessLink(e, ffdata) {
    this.footerSave = true;
    this.saveButtonDisable = true;
    this.toggleShareAccess.find(function (item) { if (item.active == 'active') { item.active = 'inactive' } });
    ffdata.active = 'active';
    this.accessActiveData = ffdata;
    this.mailParams.accessActiveData = this.accessActiveData;
    this.showShareSettings = false;
    this.saveLinkButton = true;
    this.copyLinkActive = true;
    this.linkGenerate();
  }

  initFolderShare() {
    this.shareType = this.navParams.get('ShareType');
  }
  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    document.getElementsByClassName('dropdown-menu')[0].setAttribute("style", "display: none");
  }
  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    const emailElementClick = this.emailElement;
    if (emailElementClick != undefined) {
      if (emailElementClick.inputTextValue) {
        this.onAdd({ 'display': emailElementClick.inputTextValue.replace(/[ ,]+/g, ""), 'value': emailElementClick.inputTextValue.replace(/[ ,]+/g, "") });
      }
    }
    if (targetElement.classList[0] == 'share_right_col_icon' || targetElement.classList[0] == 'share_right_icons' || targetElement.classList[0] == 'share_text_web' || targetElement.classList[0] == 'share_popup_web') {
      this.showShareSettings = true;
    }
    else {
      this.showShareSettings = false;
    }
    if (targetElement.classList[0] == 'drownIcon' || targetElement.classList[0] == 'shareEdit' || targetElement.classList[0] == 'editIcon' || targetElement.classList[0] == 'editIcons') {
      this.showEditSettings = true;
    }
    else {
      this.showEditSettings = false;
    }
  }


  shareSettingsOpen(event) {
    if (this.showShareSettings == false) {
      this.showShareSettings = true;
    } else if (this.showShareSettings == true) {
      this.showShareSettings = false;
    }
  }

  editSettingsOpen() {
    if (this.showEditSettings == false) {
      this.showEditSettings = true;
    } else if (this.showEditSettings == true) {
      this.showEditSettings = false;
    }
  }

  linkCopy() {
    let accessType: any = this.accessActiveData.id == "1" ? 'public' : 'private';
    if (!this.shareData.Email_ID.length && accessType == 'private') {
      let requiredFieldMessage = 'Please, Enter the Valid Email Id';
      var message = this.toastController.create({
        message: requiredFieldMessage,
        duration: this.configApiService.toastDuration
      });
      message.present();
    } else {
      this.copyLinkActive = true;
      this.shareDataSet['ShareID'] = this.ShareID;
      this.postShareData();
      this.showShare = false;
      this.showEditSettings = false;
      this.showLinkSettings = true;
    }
  }

  linkSettings() {
    let accessType: any = this.accessActiveData.id == "1" ? 'public' : 'private';
    if (!this.shareData.Email_ID.length && accessType == 'private') {
      let requiredFieldMessage = 'Please, Enter the Valid Email Id';
      var message = this.toastController.create({
        message: requiredFieldMessage,
        duration: this.configApiService.toastDuration
      });
      message.present();
    } else {
      this.copyLinkActive = true;
      this.shareDataSet['ShareID'] = this.ShareID;
      this.postShareData();
      this.showShare = false;
      this.showEditSettings = false;
      this.showLinkSettings = true;
    }
  }

  onSave() {
    if (this.saveButtonDisable && this.shareDataSet['ShareType'] == 'File') {
      this.sendData.sendParams = [];
      if (typeof this.shareData == "string") {
        JSON.parse(this.shareData)['mailParams'] = [];
      } else {
        this.shareData['mailParams'] = [];
      }
      this.pushTemplateProperty();
      if (this.templateFields.length != 0) {
        this.saveButtonDisable = false;
        this.pushLinkToField();
      }
    } else if (this.saveButtonDisable && this.shareDataSet['ShareType'] == 'Folder') {
      this.pushFolderProperty();
    }
    this.showLinkSettings = false;
    this.showShare = true;
    this.copyLinkActive = false;
  }

  closeLinkSetting() {
    this.showLinkSettings = false;
    this.showShare = true;
    this.copyLinkActive = false;
    this.selectedValue = '';
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.code === 'Backspace' || event.code === 'Delete') {
      this.footerSave = true;
      this.saveButtonDisable = true;
    }
    var keypress = <HTMLInputElement>event.target
    if (keypress.tagName === 'INPUT' || keypress.tagName === 'TEXTAREA') {
      this.footerSave = true;
      this.saveButtonDisable = true;
    }
  }

  // ****** MULTI SHARE IMPLEMENTATION *****//
  getTemplates() {
    let storeTemplates = this.storeWrap.storeTemplates
    Object.keys(storeTemplates).forEach(element => {
      this.arrTemplates.push(storeTemplates[element]);
    });
    this.getTemplateProperties();
  }

  getTemplateProperties() {
    this.tempId = this.shareDataSet.TemplateID;
    this.contextMenuActions[0].arrayList = this.contextMenuActions[0].arrayList.filter(obj => obj.id == this.tempId)

    this.getFields(this.tempId);
    this.fields.forEach(element => {
      if (element.FieldDataType == "HYPERLINK") {
        this.templateFields.push({ "key": element.FieldName, "value": element.DisplayName })
      }
    });
  }

  getFields(temp) {
    let data = temp
    let arrIdx = this.arrTemplates.findIndex(element => data === element["id"]);
    if (arrIdx != -1) {
      if (this.arrTemplates[arrIdx]["formLayout"]) {
        this.arrTemplateFields = this.arrTemplates[arrIdx]["formLayout"][0][0]["fields"];
      }
      this.pushParms = this.arrTemplates[arrIdx].pushParams
    }
    this.fields = this.arrTemplateFields;
  }

  onContextMenu($event, item: any): void {
    const InputRange = 210;
    const ObjClassLen = 0;
    if (
      $event.currentTarget['id'] == "emailContainer" ||
      ($event.currentTarget['id'] == "subjectContainer" && this.individualEmail) ||
      ($event.currentTarget['id'] == "messageContainer" && this.individualEmail)
    ) {
      if ($event.layerX > InputRange) {
        document.getElementsByClassName('cdk-overlay-container')[ObjClassLen].classList.add("contextPosition");
      } else {
        if (document.getElementsByClassName('cdk-overlay-container')[ObjClassLen] != undefined) {
          document.getElementsByClassName('cdk-overlay-container')[ObjClassLen].classList.remove("contextPosition");
        }
      }
      if (this.showEditSettings = true) {
        this.showEditSettings = false;
      }
      var textAreaElem;
      textAreaElem = $event.currentTarget as HTMLTextAreaElement;
      if (textAreaElem["setRangeText"] != undefined) {
        this.target = textAreaElem
      } else {
        this.target = $event.srcElement as HTMLInputElement;
      }
      this.contextMenuService.show.next({
        contextMenu: this.contextMenu,
        event: $event,
        item: item,
      });
      if (this.ComponentName == "FormGridComponent") {
        this.contextMenuActions = [
          {
            arrayList: this.contactManager.getCurrentFolderTemplate(this.driveService.objCurrentFolder),
            click: (event, item) => this.getFields(item),
            mouseover: (event, item) => this.getFields(item),
            enabled: (item) => true,
            visible: (item) => true,
            subActions: [{
              arrayList: this.arrTemplateFields,
              click: (event, item) => alert('submenu'),
              enabled: (item) => true,
              visible: (item) => true,
            }],
          }
        ];
      }
      if ($event.currentTarget['id'] == "emailContainer") {
        this.contextMenuAddContainer = "email";
        this.ContextOpen = true;
      } else if ($event.currentTarget['id'] == "subjectContainer") {
        this.contextMenuAddContainer = "subject";
        this.ContextOpen = false;
      }
      else if ($event.currentTarget['id'] == "messageContainer") {
        this.contextMenuAddContainer = "message";
        this.ContextOpen = false;
      } else if ($event.currentTarget['id'] == "smsContainer") {
        this.contextMenuAddContainer = "sms";
        this.ContextOpen = false;
      }
      $event.preventDefault();
      $event.stopPropagation();
    }
  }

  onFieldSelect(ev, fields) {
    var data = '<<' + fields.FieldName + '>>';
    this.target.focus()
    document.execCommand('insertText', false /*no UI*/, data);
    if (this.contextMenuAddContainer == "subject") {
      this.shareData.SubjectMessage.concat(data);
    } else if (this.contextMenuAddContainer == "email") {
      this.shareData.Email_ID.push(data)
      this.mail_ID.push(fields.FieldName)
      document.getElementById('emailContainer').querySelector('.iti-input')["value"] = "";
    } else if (this.contextMenuAddContainer == "message") {
      this.shareData.Message.concat(data);
    } else if (this.contextMenuAddContainer == "sms") {
      this.shareData.smsMessage.concat(data);
    }
    this.saveButtonDisable = true;
  }

  ReplaceTemplateParams(currentRowData) {
    this.SubjectMessage = this.shareData.SubjectMessage;
    if (this.shareData.Message != undefined) {
      this.Message = this.shareData.Message;
    } else {
      this.Message = '';
    }
    if (this.shareData.smsMessage != undefined) {
      this.smsMessage = this.shareData.smsMessage;
    }
    for (let rowdata in currentRowData[0]) {
      if (this.shareData.Email_ID.length > this.fieldDataMailIdx) {
        var replaceEmailvalue = this.shareData.Email_ID[this.fieldDataMailIdx].replace('<<', '')
        var emailId = replaceEmailvalue.replace('>>', '')
        if (emailId in currentRowData[0] === true) {
          this.Email_ID.push(currentRowData[0][emailId]);

        } else {
          this.Email_ID.push(this.shareData.Email_ID[this.fieldDataMailIdx]);

        }
        this.fieldDataMailIdx++
      }
      this.SubjectMessage = this.SubjectMessage.replace('<<' + rowdata + '>>', currentRowData[0][rowdata]);
      this.Message = this.Message.replace('<<' + rowdata + '>>', currentRowData[0][rowdata]);
      this.smsMessage = this.smsMessage.replace('<<' + rowdata + '>>', currentRowData[0][rowdata]);
    }
  }

  getMailConfirmation(event) {
    if (event.checked) {
      this.emailConfirmation = true;
    } else {
      this.emailConfirmation = false;
    }
  }

  pushShareFolder() {
    var shareFolder = [];
    shareFolder = JSON.parse(this.sharedFolder)
    shareFolder['path'] = []
    shareFolder['path'].push(defautSharePath);
    shareFolder['IsReadOnlyShare'] = this.editView == true ? 'NO' : 'YES';
    this.shareData.Email_ID.forEach((email_ID, i) => {
      let userIdx = this.driveService.ObjCurrentAppUsers.findIndex(users => users.email_id == email_ID);
      if (userIdx != -1) {
        let appuser = this.driveService.ObjCurrentAppUsers[userIdx];
        let pushFolderData = {
          appCode: appuser['app_code'],
          folder: shareFolder,
          userid: appuser['app_user_id'],
          shareID: this.ShareID,
          action: "sharePaste"

        }
        this.driveService.storeTodrive(pushFolderData, (respData) => {
          if (this.shareData.Email_ID.length == i + 1) {
            let toast = this.toastController.create({
              message: "Foder Move to drive successfully!..",
              duration: this.configApiService.toastDuration
            });
            toast.present();
            this.sendMailAction = false;
            this.dismissShare()
            this.loader.dismiss();
          }
        });
      } else {
        let alertMsg = "Your " + email_ID + " Id Does not exist in this app.Please get access and Try again.."
        let alert = this.alertCtrl.create({
          title: alertMsg,
          buttons: [
            {
              text: 'OK',
              handler: data => {
                this.loader.dismiss();
              }
            }
          ]
        });
        alert.present();
      }
    });
  }

  checkUser() {
    let accessList = {};
    this.shareData.Email_ID.forEach((email_ID, i) => {
      let userIdx = this.driveService.ObjCurrentAppUsers.findIndex(users => users.email_id == email_ID);
      if (userIdx != -1) {
        var infoIdx = this.ReceiverEmail.findIndex(item => item['email_id'] == email_ID)
        if (infoIdx == -1) {
          accessList['email_id'] = email_ID,
            accessList['IsReadOnlyShare'] = 'NO';
          this.ReceiverEmail.push(accessList)
        }
      }
    })
  }

  pushShareUser() {
    var shareFolder = [];
    shareFolder = JSON.parse(this.sharedFolder)
    shareFolder['path'] = []
    shareFolder['path'].push(defautSharePath);
    shareFolder['IsReadOnlyShare'] = this.editView == true ? 'NO' : 'YES';
    this.shareDataSet['ReceiverEmail'] = JSON.stringify(this.ReceiverEmail);
    this.shareDataSet['ShareID'] = this.ShareID != undefined ? this.ShareID : '',
      this.shareDataSet['SharedInfo']['sharedFolder'] = shareFolder;
    this.configApiService.pushRequest(this.shareDataSet, (respdata) => {
      this.ShareID = respdata["ShareID"]
      this.pushShareFolder();
    });
  }
  selectValue(event, i) {
    this.selectedValue = event.event;
    this.mailParams.saveLinkField = this.selectedValue;
    this.saveButtonDisable = true;
  }
  onChanges(event) {
    this.saveButtonDisable = true;
    if (this.templateFields.length == 0) {
      let toast = this.toastController.create({
        message: "Please add hyperlink field!..",
        duration: this.configApiService.toastDuration
      });
      toast.present();
    }
  }
  pushLinkToField() {
    if (this.selectedValue != '' && this.mailDataLink != '' && this.mailDataLink != undefined) {
      this.pushArrayParams = {
        PushArray: this.selectedRowData
      };
      let params = { client: this.pushParms.client, userid: this.configureService.getLoginUserID(), rptname: this.pushParms.rptname }
      var objData = Object.assign({}, params, this.pushArrayParams)
      this.configApiService.pushRequest(objData, (respdata) => {
        this.driveService.broadcastInfo({ src: 'grid-main', event: 'gridRefresh', });
      })
      this.mailIdx = 0
    }

  }

  // *** Group Of Email Sending Implementation **//

  getIndividualEmail(e) {
    this.footerSave = true;
    this.individualEmail = e.checked;
    this.saveButtonDisable = true;
  }

  templateField: boolean = false;
  groupOfData() {

    // this.selectedRowData.forEach(rowdata => {
    //   let rowData = [];
    //   rowData.push(rowdata)
    //   this.ReplaceTemplateParams(rowData);
    // })
    this.shareData.Email_ID.forEach(emailText => {
      let replaceEmailvalue = emailText.replace('<<', '').replace('>>', '');
      this.selectedField.push(replaceEmailvalue);
    })
    this.selectedField.forEach(emailId => {
      this.selectedRowData.forEach(rowdata => {
        if (rowdata[emailId] != undefined && this.shareData.Email_ID.length != 0) {
          this.templateField = true;
          if (rowdata[emailId] != "") {
            let rowEmailId = rowdata[emailId].split(',');
            rowEmailId.forEach(emailId => {
              if (this.grpEmails.includes(emailId) == false) {
                this.grpEmails.push(emailId);
              }
            })
          }
        } else {
          this.templateField = false;
          this.shareData.Email_ID.forEach(emailId => {
            if (this.grpEmails.includes(emailId) == false) {
              this.grpEmails.push(emailId);
            }
          })
        }
      })
    })
    this.splitData();
  }


  splitData() {
    if (this.grpEmails.length > this.dataIdx) {
      let emailID = this.grpEmails[this.dataIdx]
      this.pushData.push({
        'emailId': emailID,
        'shareId': "",
        "link": ""
      });
      this.groupDatas = this.selectedRowData;
      console.log("data", this.groupDatas)
      this.postSharedData(emailID);
    } else {
      this.sendGroupMail();
    }
  }

  postSharedData(emailID) {
    this.accessActiveData.id == "1" ? this.shareDataSet['SharedInfo']['accessType'] = 'public' : this.shareDataSet['SharedInfo']['accessType'] = 'private';
    this.shareDataSet["AccessType"] = this.editView == true ? 'Editable' : 'Non Editable';
    this.shareDataSet['SharedInfo'].rowData = []
    this.shareDataSet['SharedInfo'].rowData = this.groupDatas;
    this.shareDataSet['SharedInfo'].mailSendType = 'Group';
    this.shareDataSet['SharedInfo']['sharedFolder'].template = [];
    this.shareDataSet['SharedInfo']['sharedFolder'].template.push(this.driveService.storeWrap.storeTemplates[this.shareDataSet.TemplateID]);
    console.log('this.shareDataSet', this.shareDataSet)
    this.configApiService.pushRequest(this.shareDataSet, (responsedata) => {
      let pushIdx = this.pushData.findIndex(item => item.emailId == emailID);
      if (pushIdx != NoIndex) {
        this.pushData[pushIdx]['shareId'] = responsedata["ShareID"];
        this.pushData[pushIdx]['link'] = this.generateLinkUrl(responsedata["ShareID"]);
      }
      this.dataIdx++;
      this.splitData();
    });
  }

  sendGroupMail() {
    this.mailParams.Message = this.shareData.Message;
    this.mailParams.Subject = this.shareData.SubjectMessage;
    this.pushData.forEach((record, i) => {
      let mailBody = this.convertHtml(this.shareData.Message, record.link);
      this.mailScheduler = { 'TOID': record.emailId, 'CC': '', 'BCC': '', 'FROMID': this.loginUserName, 'BODY': mailBody, 'ShareID': record.shareId, 'SUBJECT': this.mailParams.Subject };
      let objPushParams = Object.assign({}, this.configApiService.driveApi.pushMailShareUser.params, this.mailScheduler);
      this.configApiService.pushRequest(objPushParams, (cbck) => {
        console.log('cbck', cbck);
        if (this.pushData.length >= i) {
          var message = this.toastController.create({
            message: 'Mail Sent Successfully',
            duration: this.configApiService.toastDuration
          });
          message.present();
          if (this.shareDataSet['ShareType'] == 'File') {
            this.pushTemplateProperty();
          }
          this.sendMailAction = false;
          this.dismissShare();
          this.driveService.broadcastInfo({ src: 'grid-main', event: 'gridRefresh', status: true });
        }
      });
    })
    this.pushData = [];
    this.grpEmails = [];
    this.selectedField = [];
  }

}


// WEBPACK FOOTER //
// ./src/pages/drive-share/drive-share.ts